<div id="container">
  <h3>{{ "settings.import-config-settings" | transloco }}</h3>
  {{ "settings.note" | transloco }}
  <div class="ui list">
    <div class="item">{{ "settings.template-types" | transloco }}</div>
    <div class="item">
      {{ 'settings.countries' | transloco: {countryAlias} }}
    </div>
    <div class="item">
      {{ "settings.sources-and-source-questions" | transloco }}
    </div>
    <div class="item">{{ "settings.global-questions" | transloco }}</div>
    <div class="item">{{ "settings.questions-q" | transloco }}</div>
    <div class="item">{{ "settings.client-questions" | transloco }}</div>
    <div class="item">{{ "settings.calculation-plans" | transloco }}</div>
    <div class="item">
      {{ 'settings.tax-return-alias-types' | transloco: {taxReturnAlias} }}
    </div>
    <div class="item">
      {{ 'settings.tax-return-alias-builder' | transloco: {taxReturnAlias} }}
    </div>
    <!-- <div class="item">{{ 'settings.smartform-and-smartform-questions' | transloco: {taxReturnAlias} }}</div> -->
  </div>

  <div class="buttons">
    <div>
      <div class="flex-grow"></div>
      <div>
        <div id="file-upload">
          <input
            type="file"
            #configFileUpload
            id="config-upload-btn"
            (change)="initFile($event.target.files)"
          />
        </div>
      </div>
    </div>

    <div>
      <div class="flex-grow"></div>

      <div>
        <div
          (click)="upload()"
          id="upload-btn"
          class="ui primary background button"
          [ngClass]="{ loading: isLoading, disabled: !configFile }"
        >
          {{ "settings.upload" | transloco }}
        </div>
      </div>
    </div>
  </div>

  <div #modal class="ui tiny modal" id="config-modal">
    <div class="icon modal-close close"></div>
    <div
      class="icon"
      [ngClass]="{
        'green-success': modalMessage?.success,
        'red-error': modalMessage?.error
      }"
    ></div>

    <div class="content">
      <h3>
        {{ modalMessage?.error && "Incorrect file setup" }}
      </h3>

      <h3>
        {{
          modalMessage?.success &&
            "The following have been successfuly imported"
        }}
      </h3>

      @if (modalMessage?.error) {
      <p>{{ modalMessage?.error?.message }}</p>
      } @if (modalMessage?.success) {
      <div>
        @for (table of modalMessage?.success?.message; track table) {
        <p>{{ table }}</p>
        }
      </div>
      }
    </div>

    <div class="actions">
      <div class="ui primary background button approve">
        {{ "settings.ok" | transloco }}
      </div>
    </div>
  </div>
</div>
